(() => {
  "use strict";

  var e = {
      3160: (e, r, o) => {
        o.d(r, {
          S: () => t,
          h: () => n
        });
        var t = (0, o(5834).system)({
            gap: {
              property: "gap",
              scale: "space"
            },
            rowGap: {
              property: "rowGap",
              scale: "space"
            },
            columnGap: {
              property: "columnGap",
              scale: "space"
            }
          }),
          n = ["display", "width", "height", "overflow", "size", "color", "opacity"];
      },
      4702: e => {
        e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
      },
      6958: e => {
        e.exports = require("@babel/runtime/helpers/toConsumableArray");
      },
      7518: e => {
        e.exports = require("styled-components");
      },
      5834: e => {
        e.exports = require("styled-system");
      }
    },
    r = {};
  function o(t) {
    var n = r[t];
    if (void 0 !== n) return n.exports;
    var a = r[t] = {
      exports: {}
    };
    return e[t](a, a.exports, o), a.exports;
  }
  o.n = e => {
    var r = e && e.__esModule ? () => e.default : () => e;
    return o.d(r, {
      a: r
    }), r;
  }, o.d = (e, r) => {
    for (var t in r) o.o(r, t) && !o.o(e, t) && Object.defineProperty(e, t, {
      enumerable: !0,
      get: r[t]
    });
  }, o.o = (e, r) => Object.prototype.hasOwnProperty.call(e, r), o.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var t = {};
  (() => {
    o.r(t), o.d(t, {
      default: () => d
    });
    var e,
      r = o(6958),
      n = o.n(r),
      a = o(4702),
      s = o.n(a),
      p = o(7518),
      l = o.n(p),
      i = o(5834),
      u = o(3160);
    const d = l().div.withConfig({
      shouldForwardProp: function (e, r) {
        return ![].concat(n()(u.h), ["order"]).includes(e) && r(e);
      }
    }).attrs(function (e) {
      var r = e.dataTestId;
      return r && {
        "data-testid": r
      };
    })(e || (e = s()(["\n  cursor: ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (e) {
      return e.onClick ? "pointer" : void 0;
    }, i.border, i.boxShadow, i.color, i.flexbox, i.layout, i.position, i.space, u.S);
  })();
  var n = exports;
  for (var a in t) n[a] = t[a];
  t.__esModule && Object.defineProperty(n, "__esModule", {
    value: !0
  });
})();